import requestor from "shared/service/requestor";

export default class LessonApi {
  constructor(isManage = false) {
    this.namespace = isManage ? '/manage/course_' : '/course/';
  }
  one = (id) => requestor.get(this.namespace + "lesson-one", { lesson_id: id });
  create = (form) => requestor.post(this.namespace + "lesson_create", form);
  delete = (id) => requestor.delete(this.namespace + "lesson_delete", { lesson_id: id });
  save = (id, form) => requestor.patch(this.namespace + "lesson-save", { lesson_id: id, Lesson: form });
  toggle = (id) => requestor.patch(this.namespace + "lesson_toggle", { lesson_id: id });

  block = {
    all: (lessonId) => requestor.get(this.namespace + "lesson-block-all", { lesson_id: lessonId }),
    create: (lessonId, typeId) =>
      requestor.patch(this.namespace + "lesson_block_create", { lesson_id: lessonId, model_type_id: typeId }),
    save: (lessonId, form) => requestor.patch(this.namespace + "lesson_block_save", { lesson_id: lessonId, LessonBlock: form }),
    delete: (lessonId, id) => requestor.delete(this.namespace + "lesson_block_delete", { lesson_id: lessonId, id: id }),
  };

  test = {
    all: ({ courseId, lessonId }) => requestor.get(this.namespace + "test_all", { course_id: courseId, lesson_id: lessonId }),
    getStats: ({ courseId, lessonId }, id) =>
      requestor.get(this.namespace + "test_stats", { course_id: courseId, lesson_id: lessonId, id: id }),
    question: {
      all: (lessonId, testId) => requestor.get(this.namespace + "test-question-all", { lesson_id: lessonId, test_id: testId }),
      create: (lessonId, testId) =>
        requestor.post(this.namespace + "test_question_create", { lesson_id: lessonId, test_id: testId }),
      save: (lessonId, form) =>
        requestor.patch(this.namespace + "test_question_save", {
          lesson_id: lessonId,
          LessonTestQuestion: form,
        }),
      delete: (lessonId, id) => requestor.delete(this.namespace + "test_question_delete", { lesson_id: lessonId, id: id }),
      answer: {
        all: (lessonId, questionId) =>
          requestor.get(this.namespace + "test-question-answer-all", {
            lesson_id: lessonId,
            question_id: questionId,
          }),
        create: (lessonId, questionId) =>
          requestor.post(this.namespace + "test_question_answer_create", { lesson_id: lessonId, question_id: questionId }),
        save: (lessonId, form) =>
          requestor.patch(this.namespace + "test_question_answer_save", {
            lesson_id: lessonId,
            LessonTestQuestionAnswer: form,
          }),
        delete: (lessonId, id) =>
          requestor.delete(this.namespace + "test_question_answer_delete", { lesson_id: lessonId, id: id }),
      },
    },
  };

  survey = {
    all: ({ courseId, lessonId }) => requestor.get(this.namespace + "survey_all", { course_id: courseId, lesson_id: lessonId }),
    getStats: ({ courseId, lessonId }, id) =>
      requestor.get(this.namespace + "survey_stats", { course_id: courseId, lesson_id: lessonId, id: id }),
    question: {
      all: (lessonId, surveyId) =>
        requestor.get(this.namespace + "survey-question-all", { lesson_id: lessonId, survey_id: surveyId }),
      create: (lessonId, surveyId) =>
        requestor.post(this.namespace + "survey_question_create", { lesson_id: lessonId, survey_id: surveyId }),
      save: (lessonId, form) =>
        requestor.patch(this.namespace + "survey_question_save", {
          lesson_id: lessonId,
          LessonSurveyQuestion: form,
        }),
      delete: (lessonId, id) => requestor.delete(this.namespace + "survey_question_delete", { lesson_id: lessonId, id: id }),
      option: {
        all: (lessonId, questionId) =>
          requestor.get(this.namespace + "survey-question-option-all", {
            lesson_id: lessonId,
            question_id: questionId,
          }),
        create: (lessonId, questionId) =>
          requestor.post(this.namespace + "survey_question_option_create", { lesson_id: lessonId, question_id: questionId }),
        save: (lessonId, form) =>
          requestor.patch(this.namespace + "survey_question_option_save", {
            lesson_id: lessonId,
            LessonSurveyQuestionOption: form,
          }),
        delete: (lessonId, id) =>
          requestor.delete(this.namespace + "survey_question_option_delete", { lesson_id: lessonId, id: id }),
      },
    },
  };

  homework = {
    all: ({ courseId, lessonId }) =>
      requestor.get(this.namespace + "homework_all", {
        course_id: courseId,
        lesson_id: lessonId,
      }),
    getStats: ({ courseId, lessonId }, id) =>
      requestor.get(this.namespace + "homework_stats", {
        course_id: courseId,
        lesson_id: lessonId,
        id: id,
      }),
  };
}
